import { Box, Container } from "@mui/material";
import Breadcrumb from "../components/Breadcrumb";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const styles = {
  Box: {
    padding: "20px",
    display: "flex",
    justifyContent: "space-evenly",
  },
  Contenedor: {
    padding: "30px",
  },
  prodDetails: {
    paddingY: "5px",
  },
  contenedorBread: {
    maxWidth: "100%",
    display: "flex",
    justifyContent: "center",
  },
};

export const Contenedor = ({
  children,
  isBox,
  isBreadCrumb,
  isProductDetails,
  isVendedor,
}) => {
  const { roles, salesData } = useSelector((state) => state.account);
  const navigate = useNavigate();

  useEffect(() => {
    if (isVendedor) {
      if (roles.includes("Vendedor") || roles.includes("Admin Ventas")) {
        navigate("/lista-clientes");
      }
    }
  }, [isVendedor, roles, navigate]);

  if (isBox)
    return (
      <>
        {isBreadCrumb && (
          <Box style={styles.contenedorBread}>
            <Box style={{ width: "60%", paddingTop: "10px" }}>
              <Breadcrumb />
            </Box>
          </Box>
        )}
        <Box style={styles.Box}>{children}</Box>;
      </>
    );
  return (
    <Container
      style={isProductDetails ? styles.prodDetails : styles.Contenedor}
    >
      {children}
    </Container>
  );
};
